
import { SystemMessageMetadataBase } from './system-message.metadata.base';


export class SystemMessageMetadata extends SystemMessageMetadataBase {
  constructor() {
    super();
  }
}

export const SYSTEM_MESSAGE_METADATA: SystemMessageMetadata = new SystemMessageMetadata();


